module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTgwMCA5NmEzMiAzMiAwIDAgMSAzMiAzMnY3NTIuN2EzMiAzMiAwIDAgMS00My45IDI5LjdMNTEyIDgwMGwtMjc2LjEgMTEwLjRBMzIgMzIgMCAwIDEgMTkyIDg4MC43VjEyOGEzMiAzMiAwIDAgMSAzMi0zMmg1NzZ6IG0tMzIgNjRIMjU2djY3My40bDI1Ni0xMDIuNCAyNTYgMTAyLjRWMTYweiBtLTEyOCA5OWEzMiAzMiAwIDAgMSAzMiAzMnYxLjJhMzIgMzIgMCAwIDEtMzIgMzJoLTI1NmEzMiAzMiAwIDAgMS0zMi0zMnYtMS4yYTMyIDMyIDAgMCAxIDMyLTMyaDI1NnoiIGZpbGw9IiMwIiBwLWlkPSI5MzkiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Bookmark-outlined.svg
// module id = JH9L
// module chunks = 75